/**
 * @generated SignedSource<<b65f87d7ad9dc728b08ee52fa5290e7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SetReportSharePermissionInput = {
  reportId: string;
  userId: string;
  permission: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type setReportSharePermissionMutation$variables = {
  input: SetReportSharePermissionInput;
};
export type setReportSharePermissionMutation$data = {
  readonly setReportSharePermission: {
    readonly share: {
      readonly id: string;
      readonly permissionType: string | null;
    } | null;
  } | null;
};
export type setReportSharePermissionMutation = {
  variables: setReportSharePermissionMutation$variables;
  response: setReportSharePermissionMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SetReportSharePermissionPayload",
    "kind": "LinkedField",
    "name": "setReportSharePermission",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ReportShare",
        "kind": "LinkedField",
        "name": "share",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "permissionType",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "setReportSharePermissionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "setReportSharePermissionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "02d34c9a711f6cec37c552ae99fd198b",
    "id": null,
    "metadata": {},
    "name": "setReportSharePermissionMutation",
    "operationKind": "mutation",
    "text": "mutation setReportSharePermissionMutation(\n  $input: SetReportSharePermissionInput!\n) {\n  setReportSharePermission(input: $input) {\n    share {\n      id\n      permissionType\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "030f291a173e807b1804faa493eb530e";

export default node;
